export default __webpack_public_path__ + "static/media/python.e3404694.svg";